module.exports = __webpack_public_path__ + "static/media/default_customer.18b1acf7.jpg";